module.exports = __webpack_public_path__ + "img/forestorytellingtour_main_05.87cdc5bb.jpg";